import { FrontendEnvironmentSettings } from '@act/shared/environment';
import { apiDomain as localApiDomain } from './local-api-domain';

const clientHost = window.location.origin;

// replace "/care." or "/consent." with "/api."
let calculatedDomain = clientHost.replace(/\/care\.|\/consent\./, '/api.');

// Local dev server, integration preview (VITE_USE_LOCAL_API), or localhost preview
const useLocalApiDomain =
  import.meta.env.DEV ||
  import.meta.env.VITE_USE_LOCAL_API === 'true' ||
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(clientHost);

if (useLocalApiDomain) {
  calculatedDomain = localApiDomain;
}

export const apiDomain = calculatedDomain;

export const environmentOverride: Partial<FrontendEnvironmentSettings> = {};
